import { h, Fragment } from "preact";

import i18n from "../i18n.js";
import talentsApi from "../api/talents";
import { setTalents } from "../store";

import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import EmptyState from "../components/EmptyState.jsx";
import Button from "../components/Button.jsx";
import SecondaryNavi from "../components/SecondaryNavi.jsx";
import ServerPaginated from "../components/ServerPaginated.jsx";
import TalentPoolItem from "../components/TalentPoolItem.jsx";
import { pick } from "lodash";

export default function TalentFavoritesPage() {
  return (
    <AppLayout
      headerWithFilter
      header={
        <AppHeader title={i18n.t("pages.titles.talentPool")}>
          <SecondaryNavi
            items={[
              {
                text: i18n.t("pages.talent_pool.header_tabs.search"),
                to: `/talents`,
              },
              {
                text: i18n.t("pages.talent_pool.header_tabs.favorites"),
                to: `/favorites`,
              },
            ]}
          />
        </AppHeader>
      }
    >
      <ServerPaginated
        id="favorites"
        fetchingMethod={(params) =>
          talentsApi.fetch({ ...pick(params, ["page"]), favorite: true })
        }
        storingMethod={setTalents}
        render={(talent) => (
          <Fragment key={talent.id}>
            <TalentPoolItem talent={talent} to={`/talents/${talent.id}`} />
          </Fragment>
        )}
        renderEmptyState={() => (
          <EmptyState
            icon="favorites_empty"
            title={i18n.t("pages.talent_favorites.empty.title")}
            description={i18n.t("pages.talent_favorites.empty.description")}
          >
            <Button iconFront="search" to="${urlBase}/talents">
              {i18n.t("pages.talent_favorites.empty.action")}
            </Button>
          </EmptyState>
        )}
      />
    </AppLayout>
  );
}
